import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { Card } from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { CreateAList } from '@thd-olt-component-react/list-forms';
import classNames from 'classnames';
import ListsContainer from './ListsContainer';
import { dataModel } from '../dataModel';
import ListsSkeleton from './ListsSkeleton';
import ListsError from './ListsError';
import ListsNullView from './ListsNullView/ListsNullView';
import { useLists } from '../useLists';
import { defaultCardContentProps } from '../../constants/responsiveClassNames';

const { number, string } = proptypes;

const Lists = ({ maxMobileListSize, iconSize, componentId }) => {
  const {
    lists, loading, error, refetchLists
  } = useLists({ page: 1 });

  const impressionData = {
    name: 'UserLists',
    component: 'UserLists',
    type: 'content',
    position: '',
    id: componentId || ''
  };

  if (error) {
    return (
      <ListsError refetchLists={refetchLists} />
    );
  }
  if (loading) {
    return (
      <ListsSkeleton />
    );
  }

  if (!Array.isArray(lists) || lists.length === 0) {
    return (
      <ImpressionProvider data={impressionData}>
        <ListsNullView componentId={componentId} />
      </ImpressionProvider>
    );
  }

  return (
    <ImpressionProvider data={impressionData}>
      <Card
        data-component="Lists"
        data-testid="lists"
        className="sui-@container sui-h-full"
        CardContentProps={{ className: classNames(defaultCardContentProps, 'sui-h-full',) }}
      >
        <ListsContainer
          lists={lists}
          iconSize={iconSize}
          maxMobileListSize={maxMobileListSize}
          componentId={componentId}
        />
      </Card>
    </ImpressionProvider>
  );
};

Lists.propTypes = {
  maxMobileListSize: number,
  iconSize: string,
  componentId: string,
};
Lists.defaultProps = {
  maxMobileListSize: 4,
  iconSize: 'small',
  componentId: undefined,
};
Lists.displayName = 'Lists';

Lists.dataModel = extend(dataModel, CreateAList);

export { Lists };
